import { Component, Input, OnInit } from '@angular/core';
import { CartItem, SupplyItem } from '@app/model/cart.model';

@Component({
    selector: 'app-cart-item-icon',
    templateUrl: './cart-item-icon.component.html',
    styleUrls: ['./cart-item-icon.component.scss']
})
export class CartItemIconComponent implements OnInit {

    @Input() cartItem: CartItem;
    icon: string;
    constructor() { }

    ngOnInit() {
        this.icon = this.cartItem instanceof SupplyItem ? 'fa-cube' : 'fa-flask';
    }

}
